import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center gap-4" }
const _hoisted_2 = { class: "flex items-center gap-0.5" }
const _hoisted_3 = { class: "flex items-center gap-0.5" }
const _hoisted_4 = { class: "text-sm ct-bg-3 min-w-[54px] rounded-md px-2 py-1 text-center" }

import { ButtonTertiaryIconSm } from "@easy/ui/buttons";
import { DesktopIcon, TabletIcon, MobileIcon } from "@easy/ui/icons";
import { usePagePreviewStore } from "../store/page-preview.store";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMiddleControls',
  setup(__props) {

const previewStore = usePagePreviewStore();

const scale = computed(() => Math.round(previewStore.scale * 100));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ButtonTertiaryIconSm), {
        class: _normalizeClass(["hover:opacity-100 hover:ct-bg-3 !p-2", {
                    'ct-bg-3 opacity-100': _unref(previewStore).viewport === 'desktop',
                    'opacity-80': _unref(previewStore).viewport !== 'desktop',
                }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(previewStore).setViewport('desktop')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DesktopIcon))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(ButtonTertiaryIconSm), {
        class: _normalizeClass(["hover:opacity-100 hover:ct-bg-3 !p-2", {
                    'ct-bg-3 opacity-100': _unref(previewStore).viewport === 'tablet',
                    'opacity-80': _unref(previewStore).viewport !== 'tablet',
                }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(previewStore).setViewport('tablet')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TabletIcon))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(ButtonTertiaryIconSm), {
        class: _normalizeClass(["hover:opacity-100 hover:ct-bg-3 !p-2", {
                    'ct-bg-3 opacity-100': _unref(previewStore).viewport === 'mobile',
                    'opacity-80': _unref(previewStore).viewport !== 'mobile',
                }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(previewStore).setViewport('mobile')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MobileIcon))
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h-8 w-[1px] ct-bg-3" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ButtonTertiaryIconSm), {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(previewStore).decrementScale())),
        class: "text-xl !leading-[0.875rem] !p-2"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("-")
        ])),
        _: 1
      }),
      _createElementVNode("span", _hoisted_4, _toDisplayString(scale.value) + "%", 1),
      _createVNode(_unref(ButtonTertiaryIconSm), {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(previewStore).incrementScale())),
        class: "text-xl !leading-[0.875rem] !p-2"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("+")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})